import type { ReactNode } from "react";
import { InventoryFormPage, InventoryListPage } from "@/components/pages";
import { Paths } from "./paths";

type Route = {
  path: string;
  component: () => ReactNode;
};

export const routes: Route[] = [
  {
    path: `${Paths.INVENTORY}${Paths.FORM}`,
    component: InventoryFormPage,
  },
  {
    path: `${Paths.INVENTORY}${Paths.LIST}`,
    component: InventoryListPage,
  },
];

export const getCurrentPath = (): string => {
  return window.location.pathname;
};

export const navigateTo = (path: string): void => {
  window.history.pushState(null, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

type Listener = () => void;
const listeners: Set<Listener> = new Set();

export const subscribeToRouteChanges = (listener: Listener): () => void => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const notifyListeners = (): void => {
  listeners.forEach((listener) => listener());
};

window.addEventListener("popstate", notifyListeners);

export const Router = ({ children }: { children?: React.ReactNode }) => {
  return <>{children}</>;
};